import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useLenis, scrollTop } from "@/hooks/useLenis";
import Home from "@/pages/Home";
import Giveaway from "@/pages/Giveaway";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollTop();
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useLenis();
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/giveaway" element={<Giveaway />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" theme="dark" richColors />
    </div>
  );
}

export default App;
